<template>
  <div id="groups-launchpad">
    <Hero v-bind:title="'Group: ' + group.name" v-bind:planTheme="planTheme">
      <h2>{{ group.description }}</h2>
      <a
        v-if="role !== 'member' && group.enabled"
        v-on:click.prevent="showModal = true"
        class="button"
        href="#"
        >{{ $t("views.group.button.create") }}</a
      >
      <Modal
        v-if="showModal"
        v-bind:modalTitle="$t('views.group.modal.header')"
        v-on:close="showModal = false"
      >
        <p>{{ $t("views.group.modal.text") }}:</p>
        <ProjectForm v-bind:groupId="group.id" />
      </Modal>
      <TabNav v-if="role !== 'Member'" v-bind:menu="tabMenu" />
    </Hero>

    <section id="group-content">
      <Breadcrumb v-bind:crumbs="breadcrumbs" />
      <router-view></router-view>
    </section>
  </div>
</template>

<script>
import Hero from "@/components/plans/Hero.vue";
import Modal from "@/components/Modal.vue";
import ProjectForm from "@/components/group/ProjectForm.vue";
import TabNav from "@/components/TabNav.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";

import { groupService } from "@/services/group.service";
import { planService } from "@/services/plan.service";

export default {
  name: "Group",
  components: {
    Hero,
    Modal,
    ProjectForm,
    TabNav,
    Breadcrumb,
  },
  data() {
    return {
      role: "",
      showModal: false,
      group: {},
      tabMenu: [
        {
          name: "Group",
          link: "/group/" + this.$route.params.groupId,
        },
        {
          name: this.$t("views.group.tab.history"),
          link: "/group/" + this.$route.params.groupId + "/history",
        },
        {
          name: this.$t("views.group.tab.edit"),
          link: "/group/" + this.$route.params.groupId + "/edit",
        },
        {
          name: this.$t("views.group.tab.archived"),
          link: "/group/" + this.$route.params.groupId + "/archive",
        },
      ],
      breadcrumbs: [],
      planTheme: "",
    };
  },
  created: function () {
    this.checkWhitelistAccess();
  },
  methods: {
    fetchGroup: function () {
      // grab the plan
      groupService
        .getGroup(this.$route.params.groupId)
        .then((group) => {
          this.role = group.role;
          this.group = group;

          planService.getPlanByMember(group.planId).then((plan) => {
            this.planTheme = plan.theme;
          });

          if (group.description) {
            this.group.description = decodeURIComponent(
              atob(group.description)
            );
          }

          // Build up the Breadcrumb
          this.breadcrumbs.push({
            name: group.planName,
            link: "/plan/" + group.planId,
          });
          this.breadcrumbs.push({
            name: group.name,
          });
        })
        .catch((err) => {
          console.error("Unable to fetch group: ", err);
          this.$router.push("/plans");
        });
    },
    checkWhitelistAccess: function () {
      groupService.whitelistAccess(this.$route.params.groupId).then((res) => {
        if (res) {
          this.fetchGroup();
        } else {
          this.$router.push("/error?err=403");
        }
      });
    },
  },
  beforeRouteUpdate(to, from, next) {
    if (from.path === "/group/" + this.$route.params.groupId + "/edit") {
      this.breadcrumbs = [];
      this.fetchGroup();
    }
    next();
  },
};
</script>

<style lang="scss">
.content-wrapper {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 70px;
}
</style>
